import React from 'react';
import DualListBox from 'react-dual-listbox';
import Chevronleft16 from '@carbon/icons-react/lib/chevron--left/16';
import Chevronright16 from '@carbon/icons-react/lib/chevron--right/16';




function arraysEqual(arr1, arr2) {
    if (arr1 == null && arr2 == null) return true;
    if (arr1 != null && arr2 == null) return false;
    if (arr1 == null && arr2 != null) return false;
    if (arr1.length !== arr2.length)
        return false;
    for (var i = arr1.length; i--;) {
        if (arr1[i] !== arr2[i])
            return false;
    }

    return true;
}

export class DualListWidget extends React.Component {

    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState) {

        return !arraysEqual(nextProps.selected, this.props.selected);
    }



    onChange = (selected) => {
        const index = this.props.idRole;

        if (!this.props.disabled) {
            this.props.onChange(selected, index);
        }
    };

    onFilter = (options, filterInput) => {
        if (!filterInput) {
            return true;
        }

        let match = false;
        if (options.division == null) {
            match = (new RegExp(filterInput, 'i')).test(options.label);
        } else {
            match = (new RegExp(filterInput, 'i')).test(options.label) || (new RegExp(filterInput, 'i')).test(options.division);
        }

        return match;
    };

    render() {

        const { options, selected } = this.props;

        return (
            <div className="bx--row">
                <div className="bx--col-lg-12">
                    <DualListBox
                        key={"DualListBox" + this.props.idRole}
                        canFilter
                        simpleValue={true}
                        filterCallback={this.onFilter}
                        filterPlaceholder="Search"
                        options={options}
                        selected={selected}
                        onChange={this.onChange}
                        disabled={this.props.disabled || false}
                        icons={{
                            moveLeft: <Chevronleft16 className="fa fa-chevron-left" />,
                            moveAllLeft: [

                                <Chevronleft16 key={0} className="fa fa-chevron-left" />,
                                <Chevronleft16 key={1} className="fa fa-chevron-left" />,
                            ],
                            moveRight: <Chevronright16 className="fa fa-chevron-right" />,
                            moveAllRight: [
                                <Chevronright16 key={0} className="fa fa-chevron-right" />,
                                <Chevronright16 key={1} className="fa fa-chevron-right" />,
                            ],
                            moveDown: <span className="fa fa-chevron-down" />,
                            moveUp: <span className="fa fa-chevron-up" />,
                        }}
                    />
                </div>
            </div>

        );
    }
}